export default __webpack_public_path__ + "static/media/carousel-2.27e6ed4b.png";